import { Environments, Markets } from '../@types/configuration';

export interface EnvironmentVariables {
  ADMIN_API_URL: string;
  ADMIN_URL: string;
  API_URL: string;
  CUSTOM_CHANNEL_API_URL: string;
  MARKET: Markets;
  ENV: Environments;
  AZURE_AD_TENANT_ID: string;
  AZURE_AD_CLIENT_ID: string;
  AZURE_AD_SCOPES: string[];
  TIMEZONE: string;
  TIMEZONE_NAME: string;
  EMAIL_LABEL: string;
  NGC_API_ENVS: string[];
}

const makeAppTitle = (): string => {
  const titleMap: Record<Markets, string> = {
    [Markets.NA]: 'North America',
    [Markets.INDIA]: 'India',
    [Markets.THAILAND]: 'Thailand',
    [Markets.KOREA]: 'Korea',
    [Markets.LATAM]: 'Latin America',
    [Markets.JAPAN]: 'Japan',
  };

  return titleMap[environment.MARKET] ?? 'ACDP-RT';
};

const environment: EnvironmentVariables = Object.seal({
  ADMIN_API_URL: import.meta.env.VITE_APP_ADMIN_API_URL!,
  ADMIN_URL: import.meta.env.VITE_APP_ADMIN_URL!,
  API_URL: import.meta.env.VITE_APP_API_URL!,
  CUSTOM_CHANNEL_API_URL: import.meta.env.VITE_APP_CUSTOM_CHANNEL_API_URL!,
  MARKET: import.meta.env.VITE_APP_MARKET as Markets,
  ENV: import.meta.env.VITE_APP_ENV as Environments,
  AZURE_AD_TENANT_ID: import.meta.env.VITE_APP_AZURE_AD_TENANT_ID!,
  AZURE_AD_CLIENT_ID: import.meta.env.VITE_APP_AZURE_AD_CLIENT_ID!,
  AZURE_AD_SCOPES: import.meta.env.VITE_APP_AZURE_AD_SCOPES!.split(','),
  TIMEZONE: import.meta.env.VITE_APP_TIMEZONE ?? '',
  TIMEZONE_NAME: import.meta.env.VITE_APP_TIMEZONE_NAME ?? '',
  EMAIL_LABEL: import.meta.env.VITE_APP_EMAIL_LABEL ?? 'Email',
  NGC_API_ENVS: import.meta.env.VITE_APP_NGC_API_ENVS ? import.meta.env.VITE_APP_NGC_API_ENVS!.split(',') : [],
});

export const acdpGroupsPrefix = 'groups-ACDP-RT';

export const isNA = environment.MARKET === Markets.NA;

export const isPROD = environment.ENV === Environments.PROD;

export const appTitle = makeAppTitle();

export const timezone = environment.TIMEZONE;

export const timezoneName = environment.TIMEZONE_NAME;

export default environment;
